import React from 'react';
import { Container, Card, Button } from 'react-bootstrap';

const PlaceholderPage = ({
  title,
  subtitle,
  icon = 'bi bi-tools',
  actions = []
}) => {
  return (
    <div className="super-placeholder-page">
      <Container fluid className="py-4">
        <Card className="border-0 shadow-sm">
          <Card.Body className="py-5 text-center">
            <div className="mb-3 text-primary">
              <i className={`${icon} display-5`}></i>
            </div>
            <h2 className="mb-2">{title}</h2>
            {subtitle && <p className="text-muted mb-4">{subtitle}</p>}
            {actions.length > 0 && (
              <div className="d-flex justify-content-center gap-3 flex-wrap">
                {actions.map((action) => (
                  <Button
                    key={action.label}
                    variant={action.variant || 'primary'}
                    onClick={action.onClick}
                    as={action.as}
                    to={action.to}
                  >
                    {action.icon && <i className={`${action.icon} me-2`}></i>}
                    {action.label}
                  </Button>
                ))}
              </div>
            )}
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
};

export default PlaceholderPage;

